import type { MembershipDetails } from '../../entities/entityTypes';
import { useRefetchMembershipDetailsMutationOptions } from '../../entities/membership/hooks/useRefetchMembershipDetailsMutationOptions';
import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

const useStopMembershipCancellation = requestBuilder.mutation<
    GeneralResponse,
    undefined,
    { id: string }
>({
    endpoint: ({ id }) => `/api/admin/memberships/${id}/stop-cancellation`,
    method: 'POST',
});

export const useStopMembershipCancellationAndRefetch = (
    membership: MembershipDetails | null,
) => {
    const refetchMembershipMutationOptions =
        useRefetchMembershipDetailsMutationOptions(membership);
    const { mutateAsync } = useStopMembershipCancellation(
        refetchMembershipMutationOptions,
    );

    const stopMembershipCancellationAsync = async (membershipId: string) => {
        return await mutateAsync({
            urlParams: {
                id: membershipId,
            },
        });
    };

    return {
        stopMembershipCancellationAsync,
    };
};
